import { hasGlobalFlag } from "../Flags";
import { DataStore } from "../generic/DataStore";
import { PlayerContextState } from "../PlayerContext";
import { Challenge } from "./Challenge";

const Challenges = new DataStore<Challenge>();

export { Challenges };

export function getCurrentChallenge(
  state: PlayerContextState,
): Challenge | undefined {
  const currentChallengeId = state.currentChallengeId;
  if (!currentChallengeId) {
    return undefined;
  }
  return Challenges.getById(currentChallengeId);
}

export function getVisibleChallenges(state: PlayerContextState): Challenge[] {
  if (!hasGlobalFlag(state, "challenges_unlocked")) {
    return [];
  }

  return Challenges.getAll().filter((challenge) => challenge.isVisible(state));
}
